




























































































































import { Component, Emit, Prop, PropSync, Watch } from 'nuxt-property-decorator'
import { AlertMessage, BibliographySearchResultItem, ErrorMessage } from '@/api'
import {
  Col,
  DataTableHeader,
  DataTable,
  SortColumn,
  setSortOrder,
  findSortColumnItem
} from '@/components/molecules/DataTable'
import { RecycleScroller } from '@/components/molecules/RecycleScroller'
import { orderBy, uniqueId } from 'lodash'
import { IconBibliography } from '@/components/molecules/IconBibliography'
import { CollectionState } from '@/types/collection'
import {
  BibliographySearchSortKey,
  CollectionFlag,
  Prefix,
  SearchTarget,
  SortOrder
} from '@/types'
import {
  alertStore,
  bibliographySearchStore,
  modalBibliographySearchStore,
  modalErrorStore
} from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'check',
        align: 'center'
      }
    ]
  },
  {
    width: 60,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'displayMaterialFormat',
        headerText: '形態',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '5',
    resizable: true,
    items: [
      {
        name: 'displayClass',
        headerText: '分類',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '33',
    resizable: true,
    items: [
      {
        name: 'displayTitle',
        headerText: 'タイトル',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '23',
    resizable: true,
    items: [
      {
        name: 'displayAuthor',
        headerText: '責任表示／年月日号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    items: [
      {
        name: 'displayPublisher',
        headerText: '出版者',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '7',
    resizable: true,
    items: [
      {
        name: 'displayPublished',
        headerText: '出版年',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '7',
    resizable: true,
    items: [
      {
        name: 'status',
        headerText: '資料状況',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'reserve',
        headerText: '',
        align: 'center'
      }
    ]
  }
]

@Component({
  components: {
    DataTable,
    DataTableHeader,
    RecycleScroller,
    IconBibliography
  }
})
export default class BibliographySearchResultsSimpleTable extends DataTable {
  @Prop({
    type: Boolean,
    required: false
  })
  reservable!: boolean

  @Prop({
    type: Boolean
  })
  allSelect!: boolean

  @Prop({
    type: Array,
    required: true
  })
  items!: BibliographySearchResultItem[]

  @Prop({
    type: Number,
    required: true
  })
  total!: number

  @Prop({
    type: Number,
    required: true
  })
  page!: number

  @Prop({
    type: Number,
    required: true
  })
  perPage!: number

  @Prop({
    type: Boolean,
    required: true
  })
  searching!: boolean

  @Prop({
    type: Number,
    required: true
  })
  scrollTop!: number

  @Prop({
    type: Number,
    required: true
  })
  rowHeight!: number

  @Prop({
    type: Boolean,
    default: false
  })
  isModal!: boolean

  @PropSync('selected', {
    type: Array,
    default: () => []
  })
  selectedUids!: string[]

  sortName: string = ''

  sortOrder: SortOrder = ''

  get itemsLength() {
    return this.items.length
  }

  get checkBoxName() {
    return uniqueId('bibliography-search-results-simple-table')
  }

  get showCols(): Col[] {
    if (this.reservable) {
      return COLS
    } else {
      return COLS.filter(col => {
        return col.items[0].name !== 'reserve'
      })
    }
  }

  get collectionState() {
    return (item: BibliographySearchResultItem) => {
      if (item.holdingCount === null) {
        return [CollectionState.NotEntry, 'red']
      }

      switch (item.collectionFlag) {
        case CollectionFlag.NotCollection:
          return [CollectionState.NotHolding, 'gray']
        case CollectionFlag.Collection:
          if (!item.canLendHandlingType) {
            return [CollectionState.CanNotLend, 'orange']
          }
          if (item.collectionStatus === '書架') {
            return [CollectionState.CanLend, 'green']
          } else if (item.collectionStatus === '貸出中') {
            return [CollectionState.Lending, 'orange']
          } else {
            return [CollectionState.CanNotLend, 'orange']
          }
        case CollectionFlag.OrderOnly:
          return [CollectionState.HasOrder, 'orange']
        case CollectionFlag.SelectionOnly:
          return [CollectionState.HasSelection, 'orange']
      }

      return ['', '']
    }
  }

  get checked() {
    return (uid: string) => this.selectedUids.includes(uid)
  }

  get isSearchTooli(): boolean {
    return (
      this.bibliographySearchStore.inputSearchOption.searchTarget.input ===
      SearchTarget.Tooli
    )
  }

  get sortedItems(): BibliographySearchResultItem[] {
    if (this.isSearchTooli && this.sortName) {
      return orderBy<BibliographySearchResultItem>(
        this.items,
        (item: BibliographySearchResultItem) => {
          return item[this.sortName as keyof BibliographySearchResultItem]
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  get bibliographySearchStore(): any {
    return this.isModal ? modalBibliographySearchStore : bibliographySearchStore
  }

  // storeと密接に絡んでいるので動作に注意すること
  @Watch('items')
  onChangeRoute(): void {
    if (this.items.length === 0) {
      this.sort({
        name: '',
        order: ''
      })
    }
  }

  isPrefixSet(prefix: string): boolean {
    return prefix === Prefix.Set
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  onClickTableRow(uid: string) {
    this.onChangeCheck(uid)
    this.onClickRow(this.items.findIndex(item => item.uid === uid))
  }

  onChangeCheck(uid: string) {
    if (this.selectedUids.includes(uid)) {
      const index = this.selectedUids.findIndex(value => uid === value)
      this.selectedUids.splice(index, 1)
    } else {
      this.selectedUids.push(uid)
    }
  }

  onUpdateScroll(startIndex: number, endIndex: number) {
    if (this.searching) {
      this.debug('onUpdateScroll', '取得中なので処理なし')
      return
    }

    if (this.total <= this.perPage) {
      this.debug('onUpdateScroll', '表示件数以下なので処理なし')
      return
    }

    if (this.itemsLength > this.page * this.perPage) {
      this.debug('onUpdateScroll', '既に取得済なので処理なし')
      return
    }

    const updateRange = 200 // 残り200行で再取得

    if (endIndex > this.page * this.perPage - updateRange) {
      this.debug('onUpdateScroll', 'scroll:end')
      this.$emit('request:next-page')
    }
  }

  sort(sortColumn: SortColumn): void {
    setSortOrder(this.showCols, sortColumn)

    const sortColItem = findSortColumnItem(this.showCols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  async onSort(sortColumn: SortColumn): Promise<void> {
    if (this.isSearchTooli) {
      this.sort(sortColumn)
      this.bibliographySearchStore.setItems(this.sortedItems)
      return
    }

    const activeRowUid = this.sortedItems[this.activeRowIndex]?.uid ?? ''

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      this.setSortKey(sortColumn.name)
      this.bibliographySearchStore.setSortOrder(sortColumn.order)
      this.bibliographySearchStore.setSaveHistory(false)
      await this.bibliographySearchStore.searchAll(true)
      this.sort(sortColumn)

      this.$emit(
        'sorted',
        this.sortedItems.findIndex(item => item.uid === activeRowUid)
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  setSortKey(sortName: string): void {
    let sortKey: BibliographySearchSortKey
    switch (sortName) {
      case 'displayMaterialFormat':
        sortKey = BibliographySearchSortKey.MaterialFormat
        break
      case 'displayClass':
        sortKey = BibliographySearchSortKey.Class
        break
      case 'displayTitle':
        sortKey = BibliographySearchSortKey.Title
        break
      case 'displaySubtitle':
        sortKey = BibliographySearchSortKey.Subtitle
        break
      case 'displayAuthor':
        sortKey = BibliographySearchSortKey.Author
        break
      case 'displayPublisher':
        sortKey = BibliographySearchSortKey.Publisher
        break
      case 'displayPublished':
        sortKey = BibliographySearchSortKey.Published
        break
      default:
        sortKey = BibliographySearchSortKey.Unspecified
    }

    this.bibliographySearchStore.setSortKey(sortKey)
  }

  @Emit('click:title')
  onClickTitle(item: BibliographySearchResultItem) {
    return item
  }

  @Emit('click:reserve')
  onClickReserve(item: BibliographySearchResultItem) {
    return item
  }

  @Emit('all-select')
  onChangeAllSelect() {}

  @Emit('scroll')
  onScroll(value: number): number {
    return value
  }
}
